import { html } from 'lit';
const Save =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6 4.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V7.828c0-.331-.132-.649-.366-.883l-1.829-1.829a1.25 1.25 0 0 0-.883-.366h-.422V7A1.75 1.75 0 0 1 14 8.75h-4A1.75 1.75 0 0 1 8.25 7V4.75zm6 0h2.25V7a.25.25 0 0 1-.25.25h-4A.25.25 0 0 1 9.75 7V4.75zm4.172-1.5H6A2.75 2.75 0 0 0 3.25 6v12A2.75 2.75 0 0 0 6 20.75h12A2.75 2.75 0 0 0 20.75 18V7.828c0-.729-.29-1.428-.805-1.944l-1.829-1.829a2.75 2.75 0 0 0-1.944-.805M9.75 14a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M12 10.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5" clip-rule="evenodd"/>
  </svg>
`;
export default Save;
